import { SchoolsForm } from "../../components/Forms";

const NewSchools = () => {
  return <SchoolsForm />;
};

export default NewSchools;
